export const Features = axios => ({
  /**
   * Get feature flags configuration
   *
   * @returns Promise
   */
  get() {
    return axios.get('/v1/features')
  }
})
